import React from 'react';
import PropTypes from 'prop-types';

const getDifficultyLabel = (d) => {
    if (d <= 1) return 'Batting Practice';
    if (d <= 2) return 'Easy';
    if (d <= 3) return 'Casual';
    if (d <= 4) return 'Steady';
    if (d <= 5) return 'Medium';
    if (d <= 6) return 'Spicy';
    if (d <= 7) return 'Sweaty';
    if (d <= 8) return 'Hard';
    if (d <= 9) return 'Brutal';
    if (d <= 10) return 'Nightmare';
    if (d <= 11) return 'Absurd';
    if (d <= 12) return 'Unhinged';
    if (d <= 14) return 'Delusional';
    if (d <= 16) return 'Masochist';
    return 'lol good luck';
};

const getDifficultyTier = (d) => {
    if (d <= 1) return 'tier-1';
    if (d <= 2) return 'tier-2';
    if (d <= 3) return 'tier-3';
    if (d <= 4) return 'tier-4';
    if (d <= 5) return 'tier-5';
    if (d <= 6) return 'tier-6';
    if (d <= 7) return 'tier-7';
    if (d <= 8) return 'tier-8';
    if (d <= 9) return 'tier-9';
    if (d <= 10) return 'tier-10';
    if (d <= 11) return 'tier-11';
    if (d <= 12) return 'tier-12';
    if (d <= 14) return 'tier-13';
    if (d <= 16) return 'tier-14';
    return 'tier-15';
};

const DifficultyBadge = ({ difficulty }) => {
    if (difficulty == null) return null;

    const tier = getDifficultyTier(difficulty);
    const label = getDifficultyLabel(difficulty);

    return (
        <span
            className={`difficulty-badge difficulty-badge--${tier}`}
            data-tooltip={`Difficulty: ${difficulty} — ${label}`}
        >
            {difficulty}
        </span>
    );
};

DifficultyBadge.propTypes = {
    difficulty: PropTypes.number,
};

export default DifficultyBadge;
